import React from 'react';

class NotFoundPage extends React.Component{
  render(){
    return(
      <h2>Page not found</h2>
    )
  }
}

export default NotFoundPage;